import { useTranslation } from "react-i18next";
import useUser from "../hooks/useUser";
import { Email, Workflow } from "../interfaces";
import EmailAliasPopover from "./EmailAliasPopover";

type Props = {
  workflow: Workflow,
  emailConfig: Email;
  onChange: (field: string, value: any) => void,
  disabled?: boolean;
}

function EmailEditorAlias(props: Props) {
  const { user } = useUser();
  const { emailConfig, onChange, workflow } = props;
  const { t } = useTranslation();

  function onSetEmailFromValue(emailFromAlias: string | null, sendFromRunner: boolean) {
    onChange('emailFromAlias', emailFromAlias ?? null);
    onChange('sendFromRunner', sendFromRunner);
  }

  if (!user)
    return null;

  return (
    <div className="flex items-center w-full relative">
      <label className="w-20 flex-shrink-0 font-gilroy font-medium text-gray-500" htmlFor="email-from">{t("From")}</label>
      <EmailAliasPopover
        value={emailConfig.emailFromAlias}
        setValue={onSetEmailFromValue}
        workflow={workflow}
        sendFromRunner={emailConfig.sendFromRunner}
        aliasDisplay={emailConfig.aliasDisplay}
        disabled={props.disabled}
        showAliases={emailConfig.emailType === "GMAIL"}
      />
    </div>
  );
}

export default EmailEditorAlias;
